import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Icon from "../../controls/Icons/Icon";
import { Row, Col, Form, Spinner, Card, Button, Table, Modal, CloseButton } from "react-bootstrap";
import ErrorHandler from "../../controls/ErrorHandler";
import { ErrorBoundary } from 'react-error-boundary';
import { dateDisplayFormater, getDateSaveFormat } from "../../../Utils";
//import useFetchWithCancellation from '../../customhooks/useFetchWithCancellation';
import useFetchWithCancellation from '../../../customhooks/useFetchWithCancellation';
import { useEffect } from 'react';
import { useRef } from 'react';
import DatePicker from "react-datepicker";
import DynamicDropdownSearchableForClient from '../../controls/DynamicDropdownSearchableForClient';
import DynamicDropdownSearchable from '../../controls/DynamicDropdownSearchable';
export default function CreateTicket() {
    const state = useSelector(state => state);
    const formRef = useRef();
    const { fetchData } = useFetchWithCancellation();
    const [validated, setValidated] = useState(false);
    const [loggedInUser, setloggedInUser] = useState(JSON.parse(localStorage.getItem("user")).Id); //loggedinUser?.Id
    const refTickettype = useRef(null);
    const refFunctionalType = useRef(null);
    const refIssueDetails = useRef(null);
    const [ticketNumber, setTicketNumber] = useState("");
    const [data, setData] = useState({
        IssueOwnerId: loggedInUser,
        CreatedDate: new Date(),
        fkTicketTypeId: "",
        fkFunctionalAreaId: "",
        fkTicketStatusId :60,
        Status: "Open",
        IssueDetails: "",
        TicketNumber:"",
        CreatedBy: JSON.parse(localStorage.getItem("user")).Id
    });

    const handleDatePickerChange = ((value, name) => {
        let dataObj = { ...data };
        dataObj[name] = value;
        if (name == "CreatedDate" && !dataObj.CreatedDate && value) {
            let NewDate = new Date(value);
            NewDate.setFullYear(NewDate.getFullYear() + 1);
            NewDate.setDate(NewDate.getDate() - 1);
            dataObj["CreatedDate"] = NewDate;
        }
        setData(c => ({ ...c, ...dataObj }));
        // dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: true });
    })
    const handleTicketOwner = (e) => {
       // alert(e.target.options[e.target.selectedIndex].value);
        setData(data => ({ ...data, IssueOwnerId: e.target.options[e.target.selectedIndex].value }));
    }
    const handleTypeofTicket = (e) => {
        if (e.target.options[e.target.selectedIndex].value !== '') {
            // e.target.options[e.target.selectedIndex].value = e.target.options[e.target.selectedIndex].value;
            // alert(e.target.options[e.target.selectedIndex].value);
            var tickTypeId = e.target.options[e.target.selectedIndex].value;
            setData(data => ({ ...data, fkTicketTypeId: e.target.options[e.target.selectedIndex].value }));;

            fetch(state.projectdetail.API + "/Ticket/GetTicketNumber?typeId=" + tickTypeId, {
                method: "Get"
            }).then(response => response.json()).then((res) => {
                if (res.Succeeded) {
                    setTicketNumber( res.Message);
                    data.TicketNumber = res.Message;
                }
                else {
                    window.alert('Something went wrong', function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
                }

            }).catch((err) => {
                if (err && err.name === 'AbortError') return;
                window.HandleError("Invoice.js ==> Invoice Get", null, null, err);
                console.log(err)
            }).finally(() => {
                //setLoading(false);
            });

           
        }
    }
    const handleFunctionalArea = (e) => {
        if (e.target.options[e.target.selectedIndex].value !== '') {
           // alert(e.target.options[e.target.selectedIndex].value);
            setData(data => ({ ...data, fkFunctionalAreaId: e.target.options[e.target.selectedIndex].value }));;
        } else {
            window.alert("Please select the functional area");
            e.target.focus();
            return false;
        }
    }
    const handleDetails = (e) => {
        if (e.target.value !== '') {
          //  alert(e.target.value);
            setData(data => ({ ...data, IssueDetails: e.target.value }));
        } else {
            window.alert("Please enter issue/ Request details");
            e.target.focus();
            return false;
        }
    }
    const handleCancel = (e) => {
        setData(data => ({ ...data, IssueDetails: "" }));
        document.getElementById("IssueDetails").value = "";
    }
   

    const SaveData = () => {
        // alert(data);
        console.log(data);
        if (data.fkTicketTypeId == '') {
            window.alert("Please select the type of the ticket", function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
            // document.getElementsByName('fkTicketStatusId').focus();
            if (refTickettype && refTickettype.current) {
                refTickettype.current.focus();
            }
            return false;
        }
        if (data.fkFunctionalAreaId == '') {
            window.alert("Please select the functional area", function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
            // document.getElementsByName('fkTicketStatusId').focus();
            if (refFunctionalType && refFunctionalType.current) {
                refFunctionalType.current.focus();
            }
            return false;
        }
        if (data.IssueDetails == '') {
            window.alert("Please enter Issue details", function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
            // document.getElementsByName('fkTicketStatusId').focus();
            if (refIssueDetails && refIssueDetails.current) {
                refIssueDetails.current.focus();
            }
            return false;
        }
        if (data && data.fkTicketTypeId !="") {

            let obj = new Object();
            obj.fkTicketTypeId = data.fkTicketTypeId;
            obj.fkFunctionalAreaId = data.fkFunctionalAreaId;
            obj.fkTicketStatusId = data.fkTicketStatusId;
            obj.IssueOwnerId = data.IssueOwnerId;
            obj.TicketNumber = ticketNumber;
            obj.CreatedDate = getDateSaveFormat(data.CreatedDate);
            obj.CreatedBy = JSON.parse(localStorage.getItem("user")).Id
            obj.ModifiedBy = JSON.parse(localStorage.getItem("user")).Id
            obj.UpdatedDate = getDateSaveFormat(new Date());
            obj.IssueDetails = data.IssueDetails;
            // obj.isActive = 1;

            fetchData(state.projectdetail.API + "/Ticket/Save", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(obj)
            }).then(response => response.json()).then((res) => {
                if (res) {
                   // res.Data.CreatedDate = new Date(res.Data.CreatedDate);
                    setData(res.Data);
                    window.toast("Ticket has been created sucessfully");
                    setValidated(false);
                    refIssueDetails.current.value = "";
                    setTicketNumber('');
                    setData(data => ({ ...data, IssueDetails: '',TicketNumber:"",fkFunctionalAreaId:'',fkTicketTypeId:'',CreatedDate:new Date()
                }))
                    
                    // setSavedSuccessfully(true);

                }
                else {
                    window.alert(res.Message, function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
                }
            }).catch((err) => {
                if (err && err.name === 'AbortError') return;
                window.HandleError("PCPInvoiceNotes.js ==> Invoice notes save", null, null, err);
                window.alert(state.projectdetail.ErrorMessage);
            }).finally(() => {
                // setLoading(false);
                // dispatch({ type: UpdtInvoiceContAction.ClearInvoiceContent });
            });

        }
    }
    //const handleDatePickerChange = ((value, name) => {
    //    let dataObj = { ...data };
    //    dataObj[name] = value;
    //    if (name == "CreatedDate" && !dataObj.CreatedDate && value) {
    //        let NewDate = new Date(value);
    //        NewDate.setFullYear(NewDate.getFullYear() + 1);
    //        NewDate.setDate(NewDate.getDate() - 1);
    //        dataObj["CreatedDate"] = NewDate;
    //    }
    //    setData(c => ({ ...c, ...dataObj }));
    //   // dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: true });
    //})
    //const handleTicketOwner = (e) => {
    //    alert(e.target.options[e.target.selectedIndex].value);
    //    setData(data => ({ ...data, IssueOwnerId: e.target.options[e.target.selectedIndex].value }));
    //}
    //const handleTypeofTicket = (e) => {
    //    if (e.target.options[e.target.selectedIndex].value !== '') {
    //        alert(e.target.options[e.target.selectedIndex].value);
    //        setData(data => ({ ...data, TicketType: e.target.options[e.target.selectedIndex].value }));;
    //    } else {
    //        window.alert("Please select the type of Ticket");
    //        e.target.focus();
    //        return false;
    //    }
    //}
    //const handleFunctionalArea = () => {
    //    setData()
    //}
    //const handleDetails = (e) => {
    //    alert(e.target.value);
    //}
    //const handleCancel = () => {

    //}
        return (<ErrorBoundary FallbackComponent={ErrorHandler}>
            <Form noValidate validated={validated} ref={formRef}>
                <div>
                    <Row>
                        <Col>
                            <Card className="border">
                                <Card.Body>
                                    <Row md={12}>
                                        <Col md={2}>
                                            <Form.Group>
                                                <Form.Label>Type of Ticket</Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                        <Form.Group>
                                                {/*<Form.Select*/}
                                                {/*    as="select"*/}
                                                {/*    onChange={handleTypeofTicket}*/}
                                                {/*>*/}
                                                {/*    <option value="">Select type of Ticket</option>*/}
                                                {/*    <option value="Incident">Incident</option>*/}
                                                {/*    <option value="Request">Request</option>*/}
                                                {/*</Form.Select>*/}
                                                <DynamicDropdownSearchable required={true} from={state.projectdetail.API + "/Misc/GetDescription?category=TicketType"} label="Description" value="Id" fetchType="get" ref={refTickettype} name="fkTicketTypeId" onDropdownChange={handleTypeofTicket} defaultval={data.fkTicketTypeId} />
                                            </Form.Group>
                                        </Col>
                                        
                                        <Col md={2}>
                                            <Form.Group>
                                                <Form.Label>Date</Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                            <DatePicker required={true} className="form-control" selected={new Date()} onChange={(val) => (handleDatePickerChange(val, "CreatedDate"))}
                                                showYearDropdown
                                                showMonthDropdown
                                                dateFormat="MM-dd-yyyy"
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}><br/></Col>
                                    </Row>
                                    <Row>
                                        <Col md={2}>
                                            <Form.Group>
                                                <Form.Label>Raised on behalf of </Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}>

                                            <DynamicDropdownSearchableForClient
                                                from={state.projectdetail.API + "/User/GetAll"}
                                                label="name"
                                                value="Id"
                                                fetchType="get"
                                                name="name"
                                                id="name"
                                                // disabled={isViewScreen}
                                                onDropdownChange={handleTicketOwner}
                                                // defaultval={loggedInUser?.Id}
                                                defaultval={loggedInUser}
                                               // defaultval = "41"
                                            />

                                        </Col>
                                        <Col md={2}>
                                            <Form.Group>
                                                <Form.Label>Functional Area</Form.Label>
                                            </Form.Group>
                                        </Col>

                                        <Col md={2}>
                                            <Form.Group>
                                                {/*<Form.Select*/}
                                                {/*    as="select"*/}
                                                {/*    onChange={handleFunctionalArea}*/}
                                                {/*>*/}
                                                {/*    <option value="">Select type of Ticket</option>*/}
                                                {/*    <option value="PCP">PCP</option>*/}
                                                {/*    <option value="Spending Plan">Spending Plan</option>*/}
                                                {/*    <option value="Invoice">Invoice</option>*/}
                                                {/*    <option value="User Access">User Access</option>*/}
                                                {/*    <option value="FMS Update">FMS Update</option>*/}
                                                {/*    <option value="Rate Update">Rate Update</option>*/}
                                                {/*    <option value="Invoice Template">Invoice Template</option>*/}
                                                {/*    <option value="Password Issue">Password Issue</option>*/}
                                                {/*</Form.Select>*/}
                                                <DynamicDropdownSearchable required={true} from={state.projectdetail.API + "/Misc/GetDescription?category=Functional Area"} label="Description" ref={refFunctionalType} value="Id" fetchType="get" name="fkFunctionalAreaId" onDropdownChange={handleFunctionalArea} defaultval={data.fkFunctionalAreaId} />
                                                
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <br />
                                    </Row>
                                    <Row>
                                        <Col md={2}>
                                            <Form.Group>
                                                <Form.Label>Status</Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                            <Form.Group>
                                                <DynamicDropdownSearchable required={true} from={state.projectdetail.API + "/Misc/GetDescription?category=Ticket Status"} label="Description" value="Id" fetchType="get" name="fkTicketStatusId" disabled onDropdownChange={handleFunctionalArea} defaultval={data.fkTicketStatusId} />
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                            <Form.Group>
                                                <Form.Label>Ticket Number</Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                            <Form.Group>
                                                <Form.Label>{ticketNumber}</Form.Label>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <br/>
                                    </Row>
                                    <Row>
                                       
                                        <Col md={8}>
                                            <Form.Group>
                                                <Form.Label>Provide details of Issue / Requirement</Form.Label>
                                                <Form.Control as="textarea" ref={refIssueDetails} rows={7} id="IssueDetails" name="IssueDetails" onChange={handleDetails}  />
                                                {/*<Form.Control as="textarea" ref={refIssueDetails} rows={7} id="IssueDetails" name="IssueDetails" />*/}
                                        </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row><br/></Row>
                                    <Row>
                                        <Col md={6}></Col>
                                        <Col md={2}>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            
                                            <Button variant="primary"
                                                style={{ align: 'right' }}
                                                onClick={SaveData}
                                                >
                                                Save
                                            </Button>
                                            &nbsp;&nbsp;
                                            
                                            <Button variant="primary"
                                                style={{ align: 'left' }}
                                                onClick={handleCancel}
                                            >
                                                Cancel
                                            </Button>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                                
                </div>
            </Form>
        </ErrorBoundary>
        )
    
}
